import * as _ from 'lodash-es';
import {IChartingLibraryWidget} from '../../../components/trading-view-chart/charting-library';
import {formatSecurityKey, SecurityKey} from '../../../models/security-key';
import {ChartWidgetSettings} from './chart-widget-settings';

export type ChartState = Record<string, unknown>;

export type ChartStateBySecurityKeyStr = Record<string, ChartState>;

export interface ChartCommonSettings {
    securityKey: SecurityKey;
    candleSize: string;
    visibleTimeRange?: [number, number];
    keepVisibleTimeRange: boolean;
    chartState: ChartStateBySecurityKeyStr;
}

export const updateChartSettingsByState = (
    chartInstance: IChartingLibraryWidget,
    settings: ChartCommonSettings,
    chartStateForSecurity: ChartState,
): Partial<ChartCommonSettings> | undefined => {
    const candleSize = chartInstance.activeChart().resolution();
    const visibleTimeRangeObj = chartInstance.activeChart().getVisibleRange();
    const securityKeyStr = formatSecurityKey(settings.securityKey);

    const savedState = settings.chartState?.[securityKeyStr];
    const ignoreZOrderChange = (_value1: any, _value2: any, index: any): boolean =>
        index === 'zorder' ? true : undefined;

    let settingsUpdate: Partial<ChartWidgetSettings> = {};

    if (!_.isEqualWith(chartStateForSecurity, savedState, ignoreZOrderChange)) {
        settingsUpdate = {
            chartState: {
                ...settings.chartState,
                [securityKeyStr]: chartStateForSecurity
            }
        };
    }

    if (settings.candleSize !== candleSize) {
        settingsUpdate.candleSize = candleSize;
    }

    const visibleTimeRange: [number, number] = [
        visibleTimeRangeObj.from,
        visibleTimeRangeObj.to
    ];

    if (!_.isEqual(visibleTimeRange, settings.visibleTimeRange)) {
        settingsUpdate.visibleTimeRange = visibleTimeRange;
    }

    return Object.keys(settingsUpdate).length
        ? settingsUpdate
        : undefined;
};
